<template>
  <div
    class="drawer"
    ref="drawer"
    v-click-outside="{
      exclude: ['drawer'],
      handler: 'hide'
    }"
  >
    <div
      ref="drawerBlackdrop"
      class="drawer-blackdrop"
      @click="hide"
    ></div>
    <slot name="drawer"></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hamburger: {},
      drawer: {},
      wrapper: {},
    };
  },
  methods: {
    toggle() {
      this.hamburger.addEventListener("click", (e) => {
        e.stopPropagation()
        this.hamburger.classList.toggle("hamburger--active");
        this.drawer.classList.toggle("drawer--active");
        this.wrapper.classList.remove("drawer--is-open");
        this.$refs.drawerBlackdrop.classList.toggle(
          "drawer-blackdrop--active"
        );
      })
    },
    hide() {
        this.$refs.drawerBlackdrop.classList.remove(
          "drawer-blackdrop--active"
        );
        this.hamburger.classList.remove("hamburger--active");
        this.drawer.classList.remove("drawer--active");
        this.wrapper.classList.remove("drawer--is-open");
    },
  },
  mounted() {
    this.hamburger = document.querySelector(".hamburger");
    this.drawer = document.querySelector(".drawer");
    this.wrapper = document.querySelector(".site-wrapper");
    this.toggle();
  },
};
</script>

<style lang="scss">
</style>
